import React, { useEffect } from "react";
import { Redirect } from "react-router-dom";

// import LoginForm from "components/Auth/Login/LoginForm";
import { useSelector } from "react-redux";
import { AppRouteURI } from "router/RoleBasedAccess";
import authActions from "components/Auth/actions";
import LoginPage from "./LoginPage";
import SimpleSnackbar from "components/common/SnackBar";
import appActions from "components/app/actions";

const LoginContainer = () => {
  const { loggedIn } = useSelector((state) => state.auth);
  const { toast } = useSelector((state) => state.app);
  const { removeToastMessage } = appActions();
  const { message, type } = toast;
  const { loadMe } = authActions();

  useEffect(() => {
    if (!loggedIn) {
      loadMe();
    }
  }, [loadMe, loggedIn]);

  return loggedIn ? <Redirect to={AppRouteURI.SCENARIO} /> : 
    <>
      <LoginPage />
      {message && (
        <SimpleSnackbar
          clearMessage={removeToastMessage}
          message={message}
          type={type}
        />
      )}
    </>
};

export default LoginContainer;
